import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'nowrap',
    minWidth: 0,
  },
  crumb: {
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  currentCrumb: {
    fontSize: theme.spacing(1.75),
    fontWeight: 500,
    lineHeight: theme.spacing(2.5),
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  separator: {
    fontSize: theme.spacing(1.5),
    lineHeight: theme.spacing(2.25),
    color: theme.palette.text.secondary,
    flexShrink: 0,
    userSelect: 'none',
  },
  moreButton: {
    padding: theme.spacing(0.25),
    borderRadius: theme.spacing(0.25),
    flexShrink: 0,
    '& svg': {
      fontSize: theme.spacing(2),
    },
  },
}));

export default useStyles;
